export const KeyMeasureFactOptions = {
	ChangeUnitType: 'change_unit_type',
	Filters: 'filters',
	Options: 'fact_options',
	RemoveFact: 'remove_fact',
	Calculation: 'fact_calculation',
	CalculationInvalid: 'fact_calculation_invalid',
	ConditionalFormatting: 'conditional_formatting',
};
